<!--===========================
=            REGISTER          =
============================-->
<template>
	<main class="transparent">
		<v-parallax dark height="900" src="../../assets/images/theme.jpg">
			<v-card :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" align="center" justify="center"
					class="mx-auto" width="500" flat>

				<v-toolbar class="transparent" flat>
					<v-toolbar-title class="primary--text">
						Register
					</v-toolbar-title>

					<v-spacer></v-spacer>


				</v-toolbar>

				<v-divider></v-divider>

				<v-form ref="form" v-model="form" class="pa-4 pt-6">
					<v-text-field v-model="email" outlined :rules="[rules.email]" filled color="deep-purple"
								  label="Email address" type="email"></v-text-field>
					<v-text-field v-model="phone" outlined filled color="deep-purple" label="Phone number">
					</v-text-field>

					<v-text-field v-model="password" outlined :rules="[rules.password, rules.length(6)]" filled
								  color="deep-purple" counter="6" label="Password" style="min-height: 96px"
								  type="password"></v-text-field>
					<v-checkbox v-model="agreement" :rules="[rules.required]" color="deep-purple">
						<template v-slot:label>
							I agree to the&nbsp;
							<a href="#" @click.stop.prevent="dialog = true">Terms </a>
							&nbsp;and&nbsp;
							<a href="#" @click.stop.prevent="dialog = true">Privacy </a>*
						</template>
					</v-checkbox>
					<v-row align="center" justify="center">
						<v-btn class="ma-5 white--text rounded-lg" fab color="indigo">
							<v-icon>mdi-facebook</v-icon>
						</v-btn>
						<v-btn class="ma-5 white--text  rounded-lg" fab color="cyan">
							<v-icon>mdi-twitter</v-icon>
						</v-btn>
						<v-btn class="ma-5 white--text  rounded-lg" fab color="red">
							<v-icon>mdi-google</v-icon>
						</v-btn>

					</v-row>
				</v-form>
				<v-divider></v-divider>
				<v-card-actions class="text-center ">


					<v-btn @click="login()" :loading="isLoading" class="white--text" color="primary" depressed>
						Login
					</v-btn>
				</v-card-actions>
				<v-dialog v-model="dialog" absolute max-width="400" persistent>
					<v-card>
						<v-card-title class="text-h5 grey--text lighten-3">
							Legal
						</v-card-title>
						<v-card-text>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
							labore et
							dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
							ut
							aliquip ex
							ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
							dolore eu
							fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
							officia
							deserunt
							mollit anim id est laborum.
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn text @click="agreement = false, dialog = false">
								No
							</v-btn>

						</v-card-actions>

						<v-btn class="grey--text" color="primary" block @click="agreement = true, dialog = false">
							Yes
						</v-btn>
					</v-card>
				</v-dialog>

			</v-card>
			</v-card>
		</v-parallax>
	</main>
</template>

<script>
	export default {
		data: () => ({
			agreement: false,
			bio: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts',
			dialog: false,
			email: undefined,
			rounded: 'lg',
			form: false,
			isLoading: false,
			password: undefined,
			phone: undefined,
			rules: {
				email: v => !!(v || '').match(/@/) || 'Please enter a valid email',
				length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
				password: v => !!(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
					'Password must contain an upper case letter, a numeric character, and a special character',
				required: v => !!v || 'This field is required',
			},
		}),
		methods: {
			login() {
				this.loading = true;
				setTimeout(() => {
					this.$router.push("/pages/page-login");
				}, 1000);
			},
			register() {
				this.loading = true;
				setTimeout(() => {
					this.$router.push("/pages/page-register");
				}, 1000);
			},


		}
	}
</script>
<!--====  End of REGISTER  ====-->